import styled from 'styled-components';
import { DEFAULT_FONT_FAMILY } from 'common/constants';

interface IStyleProps {
  backgroundColorValue?: string;
  leftValue?: string;
  rightValue?: string;
  topValue?: string;
  widthValue?: string;
  heightValue?: string;
  transformValue?: string;
  textOpenedValue?: boolean;
  viewSeeMoreLessValue?: boolean;
}

export const Root = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  position: relative;
`;

export const Title = styled.h2`
  text-align: center;
  font-family: ${DEFAULT_FONT_FAMILY};
  font-size: 26px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  margin: 76px 0px 2px 0px;
`;

export const WidgetBoxContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: ${DEFAULT_FONT_FAMILY};
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
`;

export const WidgetBoxCenter = styled.div`
  width: 575px;
  min-height: 432px;
  position: relative;
  margin: 40px 0px;
  border: solid 1px #4da0ff;
`;

export const ArrowContainer = styled.div`
  position: absolute;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 64px;
  height: 64px;
  left: ${(props: IStyleProps) => (props.leftValue ?? 'auto')};
  right: ${(props: IStyleProps) => (props.rightValue ?? 'auto')};
  top: calc(50% - 32px);
  transform: ${(props: IStyleProps) => (props.transformValue ?? 'auto')};
  border-radius: 32px;
  &:hover {
      background-color: rgba(18, 36, 66, 0.05);
  }
`;

export const WidgetBox = styled.div`
  position: static;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  padding: 46px 0px;
  box-sizing: border-box;
  background-color: #fff;
`;

export const ShadowBox = styled.div`
  position: absolute;
  left: ${(props: IStyleProps) => (props.leftValue ?? 'auto')};
  right: ${(props: IStyleProps) => (props.rightValue ?? 'auto')};
  top: ${(props: IStyleProps) => (props.topValue ?? 'auto')};
  width: ${(props: IStyleProps) => (props.widthValue ?? 'auto')};
  height: ${(props: IStyleProps) => (props.heightValue ?? 'auto')};
  background-color: rgba(77, 160, 255, 0.05);
`;

export const QuotationIconContainer = styled.div`
  display: flex;
  justify-content: center;
  padding: 0px 60px;
`;

export const Detail = styled.p`
  display: -webkit-box;
  min-height: 170px;
  text-align: justify;
  font-size: 20px;
  font-weight: 300;
  margin: ${(props: IStyleProps) => (props.viewSeeMoreLessValue?'40px 0px 3px 0px':'40px 0px')};
  max-height: ${(props: IStyleProps) => (props.textOpenedValue?'':'170px')};
  padding: 0px 60px;
  text-overflow: ${(props: IStyleProps) => (props.textOpenedValue?'':'ellipsis')};
  -webkit-line-clamp: ${(props: IStyleProps) => (props.textOpenedValue?'':'7')};
  -webkit-box-orient: ${(props: IStyleProps) => (props.textOpenedValue?'':'vertical')};
  overflow: ${(props: IStyleProps) => (props.textOpenedValue?'':'hidden')};
`;

export const SeeMoreLess = styled.div`
  width: 70px;
  font-family: ${DEFAULT_FONT_FAMILY};
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: 0.7px;
  text-align: left;
  color: #4da0ff;
  margin: 10px 60px 20px 60px;
  cursor: pointer;
`;

export const WidgetBoxBottomContainer = styled.div`
  height: 56px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

export const WidgetBoxBottom = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 4px 60px 0px 60px;
`;

export const UserInfo = styled.div`
  display: flex;
  align-items: center;
`;

export const AvatarIconContainer = styled.div`
  margin-right: 10px;
`;

export const UserLabel = styled.div`
  font-size: 15px;
  font-weight: normal;
`;

export const StarsContainer = styled.div`
`;

export const EditIconContainer = styled.div`
  cursor: pointer;
  position: absolute;
  top: ${(props: IStyleProps) => (props.topValue ?? 'calc(50% - 20px)')};
  right: -140px;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 40px;
  height: 40px;
  border-radius: 20px;
  &:hover {
    background-color: rgba(18, 36, 66, 0.05);
  }
`;

export const ReviewLink = styled.span`
  font-size: 15px;
  font-weight: 500;
  padding: 0px 60px;
  color: #4da0ff;
  cursor: pointer;
`;

export const DotsContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 48px;
`;

export const Dot = styled.div`
  width: 28px;
  height: 28px;
  border-radius: 14px;
  margin: 0px 9px;
  cursor: pointer;
  background-color: ${(props: IStyleProps) => (props.backgroundColorValue ?? 'auto')};
`;

